import React, { useEffect, useRef, useState } from "react";

import AddPublicAddressComponent from './AddPublicAddressComponent';
import TransferComponent from './TransferComponent';

import { getWalletInformation
} from '../../utils/loginHelper';

const SHOW_ADD_PUBLIC_ADDRESS_COMPONENT = 1;
const SHOW_TRANSFER_COMPONENT = 2;


function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}


export default function TransferManagerComponent(props) {

    const currTransferState = useRef();
    const publicAddress = useRef();
    const forceUpdate = useForceUpdate();
    const [showTransfer, setShowTransfer] = useState(false);
    
    useEffect(() => {
        console.log('getWalletInformation()', getWalletInformation());
        let walletInfo = getWalletInformation()
        if(walletInfo.externalAddress){
            currTransferState.current = SHOW_TRANSFER_COMPONENT;
            publicAddress.current = getWalletInformation().externalAddress;
            console.log('publicAddress.current', publicAddress.current);
            setShowTransfer(true)
            forceUpdate()
        }
        else{
            currTransferState.current = SHOW_ADD_PUBLIC_ADDRESS_COMPONENT;
            forceUpdate()
        }
    }, [props.isOpen]);
    
    return (
        <>
            {(currTransferState.current === SHOW_ADD_PUBLIC_ADDRESS_COMPONENT) && (
                <AddPublicAddressComponent
                    isOpen={props.isOpen}
                    handleModalCloseEvent={()=>{props.handleModalCloseEvent()}}
                    itemType={props.itemType}
                >
                </AddPublicAddressComponent>
            )}
            {(showTransfer || (currTransferState.current === SHOW_TRANSFER_COMPONENT)) && (
                <TransferComponent
                    isOpen={props.isOpen}
                    handleModalCloseEvent={()=>{props.handleModalCloseEvent()}}
                    item={props.item}
                    publicAddress={publicAddress.current}
                    itemType={props.itemType}
                >
                </TransferComponent>
)}
        </>
    );
}
